import React from 'react';
import { AppButton } from '../../components/AppButton/AppButton';

function NewUserButton() {
    return (
        <AppButton
            id="btnNewUser"
            variant="primary"
            size="md"
            data-bs-toggle="modal"
            data-bs-target="#modalUser"
        >
            New user
        </AppButton>
    );
}

export default NewUserButton;